/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Sub-label under the tag. Omitted on noChanges, needSelection and newMapping, which have none.
 */
export enum SurveyReplacementReviewDiffRowStatusDetail {
    JOB_MAPPING_CHANGED = 'jobMappingChanged',
    CUT_CHANGED = 'cutChanged',
    JOB_AND_CUT_CHANGED = 'jobAndCutChanged',
    NO_CUT = 'noCut',
    NO_MAPPING_OR_CUT = 'noMappingOrCut',
    NO_DATA_BEHIND_CUT = 'noDataBehindCut',
}
